import { BaseEntity } from "yt-ng-framework";

export class EPrijemnicaOpasnaMaterija extends BaseEntity {

    constructor() {
        super();
    }

    EPrijemnicaID: number = null;
    Naziv: string = null;
    Vrednost: string = null;
    Komentar: string = null;

    Deserialize(input: any) {
        super.Deserialize(input);

        this.ID = input.ID;
        this.EPrijemnicaID = input.EPrijemnicaID;
        this.Naziv = input.Naziv;
        this.Vrednost = input.Vrednost;
        this.Komentar = input.Komentar;

        return this;
    }

    Serialize(input: EPrijemnicaOpasnaMaterija) {
        return input;
    }
}
